import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { OnBehalfIndicator } from 'services/professional/step/step.interface';

export interface DynamicFormContentDetails {
  onBehalfIndicator?: OnBehalfIndicator;
  stepDescription: string;
  disclosureText?: string;
}

@Component({
  selector: 'cm-dynamic-form-content-details',
  templateUrl: './dynamic-form-content-details.component.html',
  styleUrls: ['./dynamic-form-content-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DynamicFormContentDetailsComponent {
  @Input() contentDetails: DynamicFormContentDetails;
}
